/**
 * Scrolls the app's content area back to the top.
 *
 * A page that calls `window.scrollTo` for this moves nothing: the suite's
 * `DashboardLayout` (`packages/shell`) gives its root `h-screen
 * overflow-y-hidden` and makes the inner `[data-guide="main-content"]` div the
 * scroller, so the document itself never scrolls. Both search pages carried
 * that dead call on every filter and page change — the list stayed halfway down
 * while its contents were replaced.
 *
 * Lives here rather than in `packages/shell` because importing the shell's
 * barrel initializes its i18n, which is far too much to pull in for a scroll.
 *
 * Falls back to the window for a page mounted outside that layout.
 */
export function scrollContentToTop(behavior: ScrollBehavior = 'smooth'): void {
  const container = document.querySelector<HTMLElement>('[data-guide="main-content"]');
  if (container && typeof container.scrollTo === 'function') {
    container.scrollTo({ top: 0, behavior });
    return;
  }
  window.scrollTo({ top: 0, behavior });
}
